import React, { useContext, useEffect, useState } from 'react';
import { Modal, Form, Input, Select } from 'antd';

import { CouponsContext } from '../../contexts/CouponsContext';
import { CampaignsContext } from '../../contexts/CampaignsContext';

const { Option } = Select;

const GenerateCouponForm = props => {
  const { generateCoupon, response, setResponse } = useContext(CouponsContext);
  const { campaigns } = useContext(CampaignsContext);
  const { modalVisible, setModalVisible, modal } = props;
  const [validationError, setValidationError] = useState({});
  const [loading, setLoading] = useState(false);

  const { getFieldDecorator, getFieldError } = props.form;

  const campaignError = getFieldError('campaign') || validationError.campaign;
  const numberError =
    getFieldError('number_of_coupons') || validationError.number_of_coupons;

  const closeModal = () => {
    setValidationError({});
    setModalVisible(false);
    props.form.resetFields();
  };

  const handleOk = () => {
    setLoading(true);

    props.form.validateFields((error, values) => {
      if (error) {
        setLoading(false);
        return;
      }

      generateCoupon(values);
    });
  };

  const handleCancel = () => {
    setResponse({});
    setLoading(false);
    closeModal();
  };

  const handleChange = e => {
    const currentValidation = { ...validationError };

    if (e.file) {
      currentValidation.flag = undefined;
    } else {
      const eventTarget = e.target;

      if (eventTarget) {
        const fieldName = eventTarget.name;
        currentValidation[fieldName] = undefined;
      }
    }

    if (validationError) {
      setValidationError(currentValidation);
    }
  };

  const handleSelect = () => {
    const currentValidation = { ...validationError };

    currentValidation.campaign = undefined;

    if (validationError) {
      setValidationError(currentValidation);
    }
  };

  useEffect(() => {
    if (response.errors) {
      setValidationError(response.errors);
    } else {
      setValidationError({});
    }

    if (response === 'Coupons created successfully.') {
      closeModal();
    }

    if (Object.entries(response).length !== 0) {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [response]);

  if (modal === 'generate') {
    return (
      <Modal
        title={`Generate new coupon(s)`}
        visible={modalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        confirmLoading={loading}
      >
        <Form layout="vertical" onSubmit={handleOk}>
          <Form.Item
            label="Campaign"
            validateStatus={campaignError ? 'error' : ''}
            help={campaignError || ''}
          >
            {getFieldDecorator('campaign', {
              rules: [{ required: true, message: 'Please select a campaign!' }],
              onChange: e => handleSelect(e)
            })(
              <Select
                name="campaign"
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                placeholder="Select campaign"
                style={{ width: 200 }}
              >
                {campaigns.map(campaign => {
                  return (
                    <Option key={campaign.id} value={campaign.id}>
                      {`${campaign.name}`}
                    </Option>
                  );
                })}
              </Select>
            )}
          </Form.Item>
          <Form.Item
            label="Number of coupons"
            validateStatus={numberError ? 'error' : ''}
            help={numberError || ''}
          >
            {getFieldDecorator('number_of_coupons', {
              rules: [
                {
                  required: true,
                  message: 'Please enter a number of coupons!'
                },
                {
                  pattern: /^([1-9][0-9]{0,3}|10000)$/,
                  message: 'Must be a number between 1 and 10000!'
                }
              ],
              onChange: e => handleChange(e)
            })(
              <Input name="number_of_coupons" placeholder="Number of coupons" />
            )}
          </Form.Item>
        </Form>
      </Modal>
    );
  } else {
    return null;
  }
};

const GenerateCoupon = Form.create()(GenerateCouponForm);

export default GenerateCoupon;
